const treeItem = {
    labelFiller: '[BRAK NAZWY]'
};

export default treeItem;